import { TApplicationState } from '../../types/redux';

export const selectMobileFiltersVisible = (state: TApplicationState) => {
  return state.page.mobileFiltersVisible;
};
